import React from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { get } from "../../components/Common";
import { withStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import { AccordionDetails, Tooltip } from "@material-ui/core";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SpecRoofSheetTools from "./SpecRoofSheetTools";
import SpecBeamPostTools from "./SpecBeamPostTools";
import SpecGutterDownpipeTools from "./SpecGutterDownpipeTools";
import SpecAttachmentTools from "./SpecAttachmentTools";
import ShapeDesignTools from "./SpecShapeDesignTools";
import ShapeJoinTools from "./SpecShapeJoinTools";
import SpecPitchedGableOptions from "./SpecPitchedGableOptions";
import _debounce from "lodash/debounce";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CrossCircleIcon from "@material-ui/icons/Cancel";
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from "@material-ui/icons/Clear";
import CachedIcon from "@material-ui/icons/Cached";
import LockIcon from "@material-ui/icons/Lock";
import { connect } from "react-redux";
import { addNewArea, deleteArea, updateJobParameter } from "../../redux_store/jobState";
import { changePage, toggleDesigner, toggle3DDesigner, update3DDesigner } from "../../redux_store/appState";
import { setToolSetArea, setToolSetAreaOnly } from "../../redux_store/appStateHelper";
import * as APP from "../../redux_store/appState";
import * as CONFIG from "../../redux_store/configState";
import AreaSelector from "./AreaSelector";
import BSL_SlidingView from "../../components/BSL_SlidingView";
import { Palette } from "../../AppConfig";
import BSL_Button from "../../components/BSL_Button";
import SpecOtherTools from "./SpecOtherTools";
import { GetShapeUpdateString } from "../layout/PaperFunctionHelper";
import { unlock } from "../LockBar";

const importedActions = {
    changePage,
    toggleDesigner,
    toggle3DDesigner,
    update3DDesigner,
    setToolSetArea,
    addNewArea,
    deleteArea,
    setToolSetAreaOnly,
};
const mapStateToProps = (state) => ({
    app: state.app,
    job: state.job,
});

const StyledAccordion = withStyles({
    root: {
        background: "none",
    },
    expanded: {
        margin: "0px !important",
        minHeight: "24px",
    },
})(Accordion);

const StyledAccordionSummary = withStyles({
    root: {
        minHeight: "24px",
        paddingLeft: "12px",
    },
    content: {
        marginTop: "9px",
        marginBottom: "9px",
    },
    expanded: {
        minHeight: "24px",
    },
})(AccordionSummary);

const styles = (theme) => ({
    root: {
        width: "100%",
        overflowX: "hidden",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        flex: 1,
    },
    heading: {
        font: (theme.brand.FIELDERS ? "13pt " : "12pt ") + theme.typography.fontFamilySecondary,
        fontWeight: theme.brand.FIELDERS ? "300" : "600",
        flexShrink: 0,
        color: theme.brand.FIELDERS ? Palette.Control.FieldersDarkBlue : Palette.Lysaght.DarkBlue,
    },
    panel: {
        width: "100%",
    },
    panelSummary: {},
    panelsExpanded: {
        margin: "0px !important",
    },
    panelHeading: {
        minHeight: "24px",
        margin: "0",
        zIndex: 10,
    },
    panelSummaryExpanded: {
        margin: "0",
    },
    details: {
        flexDirection: "column",
        padding: "0px 0px",
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    toolMenuText: {
        color: "white",
        textAlign: "right",
    },
    tabsRoot: {
        backgroundColor: "white",
        color: "black",
    },
    tabRoot: {
        minWidth: "0",
        width: "100%",
    },
    tabContainer: {
        minWidth: "0",
        flex: "1",
    },
    cover_start: {
        left: "0px",
        top: "0px",
        width: "30%",
        height: "100%",
        position: "absolute",
        backgroundImage: "linear-gradient(to right, rgba(0,0,0,0.5), rgba(0,0,0,0.1))",
        zIndex: 1,
    },
    cover_end: {
        right: "0px",
        top: "0px",
        width: "30%",
        height: "100%",
        position: "absolute",
        backgroundImage: "linear-gradient(to right, rgba(0,0,0,0.1), rgba(0,0,0,0.5))",
        zIndex: 1,
    },
    addNewBefore: {
        position: "absolute",
        left: "-14px",
        zIndex: 1,
    },
    addNew: {
        position: "absolute",
        right: "-14px",
        zIndex: 1,
    },
    deleteArea: {
        right: "26px",
        top: "-14px",
        zIndex: 1,
        padding: "0",
        width: "0px",
    },
    slide: {
        minHeight: 100,
        color: "#fff",
        overflow: "none",
        flex: "1 0 100%",
        borderRight: "1px solid grey",
        maxWidth: "100%",
    },
    no_border: {
        border: "none",
    },
    slim_panel: {
        maxWidth: "250px",
        width: "250px",
    },
    lockOverlay: {
        left: "0px",
        right: "0px",
        top: "48px",
        bottom: "0px",
        position: "absolute",
        backgroundImage: "linear-gradient(to right, rgba(0,0,0,0.1), rgba(0,0,0,0.3))",
        zIndex: 1,
        color: "white",
        verticalAlign: "middle",
        cursor: "pointer",
    },
    lockText: {
        background: "#33333380",
        width: "100%",
        padding: "20px",
        marginTop: "150px",
    },
});

export function LockDiv(props) {
    const app = useSelector((state) => state.app);
    const job = useSelector((state) => state.job);
    const dispatch = useDispatch();

    const isPending = job?.OrderStatus === "PENDING";
    const isAccepted = job?.OrderStatus === "ACCEPTED";
    const isAppLocked = job?.App?.Locked;
    const UNLOCKED = app?.designer?.[APP.UNLOCKED];
    const customListIsOpen = app?.designer?.[APP.CUSTOM_COMPONENT_LIST_IS_OPEN] ?? false;
    const hasCustomBOM = (job?.QuoteParameters?.BOM?.OrderList?.items?.length ?? 0) > 0 || customListIsOpen;

    const locked = ((isPending || isAccepted || isAppLocked) && !UNLOCKED) || hasCustomBOM;
    if (!locked) return null;

    let lockInfo = { reason: "", message: "LOCKED" };

    if (isPending && !UNLOCKED) {
        lockInfo = {
            reason: "PENDING",
            message: "LOCKED WHILE ORDER PENDING REVIEW",
        };
    } else if (isAccepted && !UNLOCKED)  {
        lockInfo = {
            reason: "ORDERED",
            message: "LOCKED AS JOB HAS BEEN ORDERED",
        };
    } else if (isAppLocked && !UNLOCKED) {
        lockInfo = {
            reason: "APP_LOCKED",
            message: "LOCKED",
        };
    } else if (hasCustomBOM) {
        lockInfo = {
            reason: "CUSTOMISED",
            message: "JOB HAS A CUSTOMISED COMPONENT LIST",
        };
    }

    const { reason: lockReason, message: lockMessage } = lockInfo;

    const handleClick = () => {
        if (app.user.Role >= 90 && props?.openMessageBox && lockReason !== "CUSTOMISED") {
            unlock(props.openMessageBox, app, job, dispatch);
        } else if (lockReason === "CUSTOMISED") {
            unlock(props.openMessageBox, app, job, dispatch, lockReason);
        }
    };

    return (
        <div className={props.classes.lockOverlay} onClick={handleClick}>
            <div className={props.classes.lockText}>
                <LockIcon fontSize="medium" />
                <br />
                {lockMessage}
                {lockReason === "CUSTOMISED" && (
                    <>
                        <br />
                        CLICK TO UNLOCK
                    </>
                )}
            </div>
        </div>
    );
}

function SpecToolAccordian(props) {
    const dispatch = useDispatch();
    const scrollEl = React.useRef(null);
    const { classes, job, app, setToolSetArea, addNewArea, openMessageBox } = props;
    const DRAWER_TOOLSET_EXPANDED = props.app.designer.designer3D[APP.DRAWER_TOOLSET_EXPANDED];

    let areaIndex = props.app.designer[APP.TOOL_DRAWER_AREA];
    if (areaIndex >= job.AreaSpecifications.length) areaIndex = job.AreaSpecifications.length - 1;
    const carportMode = job?.DesignParameters?.CarportMode === 1;

    const [selectedIndex, setSelectedIndex] = React.useState(areaIndex);
    const [scrollLeft, setScrollLeft] = React.useState(0);

    let selectedAreaIndex = selectedIndex !== null ? selectedIndex : areaIndex;
    if (selectedAreaIndex >= job.AreaSpecifications.length) selectedAreaIndex = job.AreaSpecifications.length - 1;

    React.useEffect(() => {
        setSelectedIndex(areaIndex);
    }, [areaIndex]);

    const updateArea = React.useCallback(
        _debounce((newValue, tool) => {
            dispatch(setToolSetAreaOnly(newValue, tool));
        }, 1500),
        []
    );

    if (job.AreaSpecifications.length === 0) {
        return (
            <div className={classes.root}>
                <div
                    style={{
                        width: "100%",
                        height: "400px",
                        paddingTop: "250px",
                    }}
                >
                    <BSL_Button tight label="Add Area" onClick={() => addNewArea(false)} />
                </div>
            </div>
        );
    }

    const handleSelectedIndexChanged = (newValue, tool = null) => {
        updateArea(newValue, tool);
        setSelectedIndex(newValue);
    };

    let num_areas = job.AreaSpecifications.length;

    const engineeringHashCode = get(job, "QuoteParameters.ENGINEERING.engineeringHashCode");
    const currentHashCode = GetShapeUpdateString(false, true);
    const OVERSTRESS_FACTOR = 1.03;
    const MaxResults =
        Number(get(job, "QuoteParameters.ENGINEERING.EngineeringResults.MaxResultOverAll")) / OVERSTRESS_FACTOR;
    const MaxResultText = get(job, "QuoteParameters.ENGINEERING.EngineeringResults.maxResultOverAllText");

    let engValid = false;
    if (engineeringHashCode && currentHashCode && engineeringHashCode === currentHashCode) engValid = true;

    let has_gable = false;
    for (let area of job.AreaSpecifications) {
        if (
            area?.SHAPE?.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL ||
            area?.SHAPE?.DesignType === CONFIG.DESIGN_TYPES.PITCHED
        ) {
            has_gable = true;
        }
    }

    let multi_view = false;
    if (props.width?.width && props.width?.width > 400) {
        multi_view = true;
    }

    let panel_classes = classes.slide;
    if (multi_view) panel_classes = classes.slide + " " + classes.slim_panel;

    if (!multi_view && scrollEl?.current) {
        scrollEl.current.scrollLeft = 0;
    }

    const onScroll = (e) => {
        if (e.target.scrollLeft !== scrollLeft) setScrollLeft(e.target.scrollLeft);
    };

    return (
        <div className={classes.root}>
            <div style={{ background: "#F4F4F4", marginLeft: -scrollLeft + "px" }}>
                <AreaSelector
                    multi_view={multi_view}
                    page={DRAWER_TOOLSET_EXPANDED}
                    showHeader={true}
                    selectedAreaIndex={selectedAreaIndex}
                    onChange={props.multi_view ? null : handleSelectedIndexChanged}
                />
            </div>
            <div
                style={{
                    flex: "1",
                    overflowX: multi_view ? "auto" : "hidden",
                    overflowY: "auto",
                }}
                ref={scrollEl}
                onScroll={onScroll}
            >
                {!carportMode && (
                    <>
                        <StyledAccordion
                            expanded={DRAWER_TOOLSET_EXPANDED === "attachment_tool"}
                            onChange={() => {
                                setSelectedIndex(Math.trunc(areaIndex));
                                setToolSetArea(
                                    areaIndex,
                                    DRAWER_TOOLSET_EXPANDED === "attachment_tool" ? "none" : "attachment_tool"
                                );
                            }}
                        >
                            <StyledAccordionSummary
                                className={
                                    classes.panelHeading +
                                    (DRAWER_TOOLSET_EXPANDED === "attachment_tool"
                                        ? " " + classes.panelSummaryExpanded
                                        : "")
                                }
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Typography className={classes.heading} style={{ marginLeft: scrollLeft + "px" }}>
                                    ATTACHMENT / HOUSE
                                </Typography>
                            </StyledAccordionSummary>
                            <AccordionDetails className={classes.details} style={{ alignItems: "center" }}>
                                <LockDiv classes={classes} openMessageBox={openMessageBox} />
                                <SpecAttachmentTools areaIndex={areaIndex} />
                            </AccordionDetails>
                        </StyledAccordion>
                        <StyledAccordion
                            expanded={DRAWER_TOOLSET_EXPANDED === APP.SHAPE_TOOL}
                            onChange={() =>
                                setToolSetArea(
                                    areaIndex,
                                    DRAWER_TOOLSET_EXPANDED === APP.SHAPE_TOOL ? "none" : APP.SHAPE_TOOL
                                )
                            }
                            style={multi_view ? { width: "max-content" } : {}}
                        >
                            <StyledAccordionSummary
                                className={
                                    classes.panelHeading +
                                    (DRAWER_TOOLSET_EXPANDED === APP.SHAPE_TOOL
                                        ? " " + classes.panelSummaryExpanded
                                        : "")
                                }
                                expandIcon={<ExpandMoreIcon />}
                                style={
                                    multi_view
                                        ? { width: props.width?.width ? props.width?.width - 18 : "max-content" }
                                        : {}
                                }
                            >
                                <Typography className={classes.heading} style={{ marginLeft: scrollLeft + "px" }}>
                                    SHAPE / DIMENSIONS
                                </Typography>
                            </StyledAccordionSummary>
                            <AccordionDetails className={classes.details}>
                                <LockDiv classes={classes} openMessageBox={openMessageBox} />
                                <BSL_SlidingView index={multi_view ? 0 : selectedAreaIndex * 2}>
                                    {job.AreaSpecifications.map((area, index) => [
                                        <div
                                            key={index}
                                            value={areaIndex}
                                            index={index}
                                            className={
                                                panel_classes + " " + (index >= num_areas - 1 ? classes.no_border : "")
                                            }
                                        >
                                            <ShapeDesignTools key={index} areaIndex={index} />
                                        </div>,
                                        <div
                                            key={100 + index}
                                            className={classes.slide + " " + (index >= num_areas - 1 ? "hidden" : "")}
                                            value={areaIndex}
                                            index={index + 0.5}
                                            style={multi_view ? { maxWidth: "165px" } : {}}
                                        >
                                            <ShapeJoinTools key={index} areaIndex={index} />
                                        </div>,
                                    ])}
                                </BSL_SlidingView>
                            </AccordionDetails>
                        </StyledAccordion>
                    </>
                )}
                <StyledAccordion
                    expanded={DRAWER_TOOLSET_EXPANDED === APP.ROOFSHEET_TOOL}
                    onChange={() => {
                        setSelectedIndex(Math.trunc(areaIndex));
                        setToolSetArea(
                            areaIndex,
                            DRAWER_TOOLSET_EXPANDED === APP.ROOFSHEET_TOOL ? "none" : APP.ROOFSHEET_TOOL
                        );
                    }}
                    style={multi_view ? { width: "max-content" } : {}}
                >
                    <StyledAccordionSummary
                        className={
                            classes.panelHeading +
                            (DRAWER_TOOLSET_EXPANDED === APP.ROOFSHEET_TOOL ? " " + classes.panelSummaryExpanded : "")
                        }
                        expandIcon={<ExpandMoreIcon />}
                        style={
                            multi_view ? { width: props.width?.width ? props.width?.width - 18 : "max-content" } : {}
                        }
                    >
                        <Typography className={classes.heading} style={{ marginLeft: scrollLeft + "px" }}>
                            ROOF SHEETING & FLASHINGS
                        </Typography>
                    </StyledAccordionSummary>
                    <AccordionDetails className={classes.details}>
                        <LockDiv classes={classes} openMessageBox={openMessageBox} />
                        <BSL_SlidingView index={multi_view ? 0 : Math.floor(selectedAreaIndex)}>
                            {job.AreaSpecifications.map((area, index) => (
                                <div
                                    key={index}
                                    value={areaIndex}
                                    index={index}
                                    className={panel_classes + " " + (index >= num_areas - 1 ? classes.no_border : "")}
                                >
                                    <SpecRoofSheetTools areaIndex={index} />
                                </div>
                            ))}
                        </BSL_SlidingView>
                    </AccordionDetails>
                </StyledAccordion>
                <StyledAccordion
                    expanded={DRAWER_TOOLSET_EXPANDED === APP.GUTTERS_DOWNPIPES_TOOL}
                    onChange={() => {
                        setSelectedIndex(Math.trunc(areaIndex));
                        setToolSetArea(
                            areaIndex,
                            DRAWER_TOOLSET_EXPANDED === APP.GUTTERS_DOWNPIPES_TOOL ? "none" : APP.GUTTERS_DOWNPIPES_TOOL
                        );
                    }}
                >
                    <StyledAccordionSummary
                        className={
                            classes.panelHeading +
                            (DRAWER_TOOLSET_EXPANDED === APP.GUTTERS_DOWNPIPES_TOOL
                                ? " " + classes.panelSummaryExpanded
                                : "")
                        }
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <Typography className={classes.heading}>GUTTERS & DOWNPIPES</Typography>
                    </StyledAccordionSummary>
                    <AccordionDetails className={classes.details}>
                        <LockDiv classes={classes} openMessageBox={openMessageBox} />

                        <BSL_SlidingView index={multi_view ? 0 : Math.floor(selectedAreaIndex)}>
                            {job.AreaSpecifications.map((area, index) => (
                                <div
                                    key={index}
                                    value={areaIndex}
                                    index={index}
                                    className={panel_classes + " " + (index >= num_areas - 1 ? classes.no_border : "")}
                                >
                                    <SpecGutterDownpipeTools areaIndex={index} />
                                </div>
                            ))}
                        </BSL_SlidingView>
                    </AccordionDetails>
                </StyledAccordion>

                {has_gable && (
                    <StyledAccordion
                        expanded={DRAWER_TOOLSET_EXPANDED === APP.PITCHED_GABLE_TOOL}
                        onChange={() => {
                            setSelectedIndex(Math.trunc(areaIndex));
                            setToolSetArea(
                                areaIndex,
                                DRAWER_TOOLSET_EXPANDED === APP.PITCHED_GABLE_TOOL ? "none" : APP.PITCHED_GABLE_TOOL
                            );
                        }}
                    >
                        <StyledAccordionSummary
                            className={
                                classes.panelHeading +
                                (DRAWER_TOOLSET_EXPANDED === APP.PITCHED_GABLE_TOOL
                                    ? " " + classes.panelSummaryExpanded
                                    : "")
                            }
                            expandIcon={<ExpandMoreIcon />}
                        >
                            <Typography className={classes.heading}>GABLE OPTIONS</Typography>
                        </StyledAccordionSummary>
                        <AccordionDetails className={classes.details}>
                            <LockDiv classes={classes} openMessageBox={openMessageBox} />
                            <BSL_SlidingView index={multi_view ? 0 : Math.floor(selectedAreaIndex)}>
                                {job.AreaSpecifications.map((area, index) => (
                                    <div
                                        key={index}
                                        value={areaIndex}
                                        index={index}
                                        className={
                                            panel_classes + " " + (index >= num_areas - 1 ? classes.no_border : "")
                                        }
                                    >
                                        {[CONFIG.DESIGN_TYPES.PITCHED, CONFIG.DESIGN_TYPES.GABLE_PORTAL].includes(
                                            job.AreaSpecifications[index].SHAPE.DesignType
                                        ) && (
                                            <SpecPitchedGableOptions
                                                currentHashCode={currentHashCode}
                                                areaIndex={index}
                                            />
                                        )}
                                        {job.AreaSpecifications[index].SHAPE.DesignType ===
                                            CONFIG.DESIGN_TYPES.FLAT && (
                                            <div style={{ color: "darkgrey", paddingTop: "100px" }}>
                                                NO GABLE OPTIONS FOR THIS AREA
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </BSL_SlidingView>
                        </AccordionDetails>
                    </StyledAccordion>
                )}
                {job?.OverrideEngineering && (
                    <div
                        style={{
                            width: "100%",
                            background: "#1a3061",
                            color: "white",
                            textTransform: "uppercase",
                        }}
                    >
                        {job?.OverrideEngineering}
                        <IconButton
                            aria-label="delete"
                            size="small"
                            onClick={() => {
                                dispatch(updateJobParameter("OverrideEngineering", false));
                            }}
                            style={{ color: "#dddddd" }}
                        >
                            <ClearIcon fontSize="inherit" />
                        </IconButton>
                    </div>
                )}
                {job?.AcceptedWarnings &&
                    job.AcceptedWarnings.map((warning) => (
                        <div
                            style={{
                                width: "100%",
                                background: "#1a3061",
                                color: "white",
                                textTransform: "uppercase",
                            }}
                        >
                            {warning}
                            {!warning.includes("UNLOCKED BY:") && !warning.includes("ACCEPTED BY") && (
                                <IconButton
                                    aria-label="delete"
                                    size="small"
                                    onClick={() => {
                                        dispatch(
                                            updateJobParameter(
                                                "AcceptedWarnings",
                                                job.AcceptedWarnings.filter((e) => e !== warning)
                                            )
                                        );
                                    }}
                                    style={{ color: "#dddddd" }}
                                >
                                    <ClearIcon fontSize="inherit" />
                                </IconButton>
                            )}
                        </div>
                    ))}
                <StyledAccordion
                    expanded={DRAWER_TOOLSET_EXPANDED === APP.BEAMS_AND_POSTS_TOOL}
                    onChange={() => {
                        setSelectedIndex(Math.trunc(areaIndex));
                        setToolSetArea(
                            areaIndex,
                            DRAWER_TOOLSET_EXPANDED === APP.BEAMS_AND_POSTS_TOOL ? "none" : APP.BEAMS_AND_POSTS_TOOL
                        );
                    }}
                >
                    <StyledAccordionSummary
                        className={
                            classes.panelHeading +
                            (DRAWER_TOOLSET_EXPANDED === APP.BEAMS_AND_POSTS_TOOL
                                ? " " + classes.panelSummaryExpanded
                                : "")
                        }
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <Tooltip title={window.debug && MaxResultText ? MaxResultText : ""}>
                            <Typography className={classes.heading}>
                                {engValid && MaxResults ? (
                                    MaxResults <= 1 ? (
                                        <CheckCircleIcon
                                            style={{ color: "#008200", position: "absolute", top: "11px" }}
                                        />
                                    ) : (
                                        <CrossCircleIcon
                                            style={{ color: "#8c1212", position: "absolute", top: "11px" }}
                                        />
                                    )
                                ) : (
                                    <CachedIcon
                                        style={{
                                            color: "#b37f0b",
                                            position: "absolute",
                                            top: "11px",
                                            animation: app?.loadingEngineering ? "spin 4s linear infinite" : "",
                                        }}
                                    />
                                )}
                                <span style={{ marginLeft: "30px" }}>BEAMS & POSTS</span>
                            </Typography>
                        </Tooltip>
                    </StyledAccordionSummary>
                    <AccordionDetails className={classes.details}>
                        <LockDiv classes={classes} openMessageBox={openMessageBox} />
                        <BSL_SlidingView index={multi_view ? 0 : Math.floor(selectedAreaIndex)}>
                            {job.AreaSpecifications.map((area, index) => (
                                <div
                                    key={index}
                                    value={areaIndex}
                                    index={index}
                                    className={panel_classes + " " + (index >= num_areas - 1 ? classes.no_border : "")}
                                >
                                    <SpecBeamPostTools currentHashCode={currentHashCode} areaIndex={index} />
                                </div>
                            ))}
                        </BSL_SlidingView>
                    </AccordionDetails>
                </StyledAccordion>

                {!carportMode && (
                    <StyledAccordion
                        expanded={DRAWER_TOOLSET_EXPANDED === APP.OTHER_TOOLS}
                        onChange={() => {
                            setSelectedIndex(Math.trunc(areaIndex));
                            setToolSetArea(
                                areaIndex,
                                DRAWER_TOOLSET_EXPANDED === APP.OTHER_TOOLS ? "none" : APP.OTHER_TOOLS
                            );
                        }}
                    >
                        <StyledAccordionSummary
                            className={
                                classes.panelHeading +
                                (DRAWER_TOOLSET_EXPANDED === APP.OTHER_TOOLS ? " " + classes.panelSummaryExpanded : "")
                            }
                            expandIcon={<ExpandMoreIcon />}
                        >
                            <Typography className={classes.heading}>OTHER TOOLS</Typography>
                        </StyledAccordionSummary>
                        <AccordionDetails className={classes.details}>
                            <LockDiv classes={classes} openMessageBox={openMessageBox} />
                            <BSL_SlidingView index={multi_view ? 0 : Math.floor(selectedAreaIndex)}>
                                {job.AreaSpecifications.map((area, index) => (
                                    <div
                                        key={index}
                                        value={areaIndex}
                                        index={index}
                                        className={
                                            panel_classes + " " + (index >= num_areas - 1 ? classes.no_border : "")
                                        }
                                    >
                                        <SpecOtherTools currentHashCode={currentHashCode} areaIndex={index} />
                                    </div>
                                ))}
                            </BSL_SlidingView>
                        </AccordionDetails>
                    </StyledAccordion>
                )}
            </div>
        </div>
    );
}

SpecToolAccordian.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, importedActions)(withStyles(styles)(SpecToolAccordian));
